import { useStudioConfig } from './studio-config-context'

export type StudioAppSource = 'STUDIO' | 'FREEMODE'

export function isFreemodeAppSource(
  appSource: StudioAppSource | undefined,
): appSource is 'FREEMODE' {
  return appSource === 'FREEMODE'
}

export function useIsFreemode(): boolean {
  return isFreemodeAppSource(useStudioConfig()?.appSource)
}
